import {
  useGetWorkspaceFoldersQuery,
  useMovePlaybookMutation,
} from '@carboncopyco/data';
import type { Playbook } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';

import { MoveAssetModal } from '../../../MoveAssetModal';

type MovePlaybookModalProps = {
  onClose: () => void;
  playbook: Playbook;
  organizationId: string;
  workspaceId: string;
};

export const MovePlaybookModal = ({
  onClose,
  playbook,
  organizationId,
  workspaceId,
}: MovePlaybookModalProps) => {
  const [movePlaybook, { isLoading }] = useMovePlaybookMutation();
  const { data: folders } = useGetWorkspaceFoldersQuery({
    organizationId,
    workspaceId,
  });

  const playbookFolderId = String(playbook.folderId);

  return (
    <MoveAssetModal
      close={onClose}
      origin={{
        id: playbook.folderId,
        workspaceId,
        entity: playbookFolderId === '0' ? 'workspace' : 'folder',
      }}
      onSubmit={(targetFolderId) => {
        movePlaybook({
          organizationId,
          workspaceId,
          folderId: targetFolderId,
          id: playbook.id,
          currentFolderId: playbookFolderId,
        })
          .unwrap()
          .then(() => {
            const folderName = folders.find(
              (folder) => String(folder.id) === targetFolderId
            )?.name;
            notify.success(
              `Playbook successfully moved to ${targetFolderId === '0' ? 'workspace' : folderName}`
            );
          })
          .catch(() =>
            notify.error(
              'An error occurred while moving the asset. Please try again'
            )
          )
          .finally(onClose);
      }}
      blockOtherWorkspaces
      isLoading={isLoading}
      tooltipText="This asset cannot be moved between workspaces at the moment, but it will be supported soon!"
    />
  );
};
